class NavState {
  sidebarExpandedSections: { [name: string]: boolean } = {};
  isHamburgerOpen: boolean = false;
}

export const navState = new NavState();
